import { ProjectContext, projectStore } from "@droid/project-interface"
import { ButtonConfirm } from "@fanfanlo"
import { Box, Button } from "@mui/material"
import { useContext } from "react"
import { useTranslation } from "react-i18next"
export function DeleteProjectButton() {
    const { t } = useTranslation("droid-project/project/ui/components/content")
    const project = useContext(ProjectContext)
    const projectId = project.id
    const handleDelete = () => {
        projectStore.deleteProject(projectId)
    }
    const content = <Box style={{textAlign: 'center'}}>
        <span style={{color:"#FF0000"}}>{project.name}</span>
        <br/>
        <span>{t('content.confirmDelete')}</span>
    </Box>
    return (
        <>
            <ButtonConfirm
            title={t('content.title')}  
            content={content}
            onConfirm={handleDelete}>
                <Button
                id="project-simple-title-list-del-btn"
                data-id="project-simple-title-list-del-btn"
                >
                    {t('content.delete')}
                </Button>
            </ButtonConfirm>
        </>
    )
}
